import { useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import { callGetParticipants } from 'services/ivr.service';

const CallParticipants = ({ callSid }) => {
  const [participants, setParticipants] = useState([]);

  useEffect(() => {
    callGetParticipants(callSid).then(setParticipants);
  }, []);

  return (
    <Stack direction="row" spacing={2}>
      {participants.map((participant, index) => (
        <Avatar
          key={index}
          alt={participant.name}
          src={participant.avatar}
          sx={{ width: 56, height: 56 }}
        />
      ))}
    </Stack>
  );
};

export default CallParticipants;
